import { useState } from "react";
import { updateItem } from "../../../lib-pos";
import { FormInput, ModalForm, useStyles, FormBox, FormGroup } from "../../../components";

export function JuncoMenuOpitonModal(props) {
  const {
    shopInfo,
    item,
    visible,
    setVisible,
    onload,
  } = props;

  const { gStyle, colors } = useStyles()

  const title = `필수메뉴 세팅 (${item.itemName2})`;

  const [isLoading, setIsLoading] = useState(false);
  const [isMustMenu, setIsMustMenu] = useState(item.isMustMenu ? true : false)

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      if (shopInfo.posName !== "OASIS_POS") throw Error("INVALID POSNAME")

      let res = await updateItem({ shopInfo, id: item.id, body: { isMustMenu } })
      if (res.err) throw new Error("저장에 실패 하였습니다.!\n" + res.err.message);
      await onload();
    } catch (e) {
      alert(e.message);
    } finally {
      setIsLoading(false);
      setVisible(false);
    }
  };

  return (
    <ModalForm
      visible={visible} setIsVisible={setVisible} title={title}
      onSubmit={onSubmit} isLoading={isLoading}
    >
      <p style={{ ...gStyle.text, color: colors.danger, textAlign: "center" }}>준코 전용 기능입니다.</p>
      <FormGroup>
        <FormBox>
          <FormInput
            label="필수메뉴 여부"
            name="isMustMenu"
            inputType="checkbox"
            checked={isMustMenu}
            onChange={() => {
              setIsMustMenu(!isMustMenu)
            }}
          />
        </FormBox>
      </FormGroup>
    </ModalForm>
  )
}
